import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { NZ_I18N, es_ES } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import {provideHttpClient,withInterceptors} from '@angular/common/http';

import { authInterceptor} from './core/auth/interceptors/auth.interceptor';

import { routes } from './app.routes';

registerLocaleData(es);

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(withInterceptors([
        authInterceptor
    ])),

        {
            provide: NZ_I18N,
            useValue: es_ES
        }
    ]
};